
import Popup from 'vux/src/components/popup/index.vue'

export default {
name: "consignment",
components:{Popup},
data(){
return{
tabIndex:1,
wrapperHeight:0,
allLoaded:false,
config:{
title:'库存结余',
url:'api/consignment-stock/page',
tabList:['库存结余','出入库明细'],
property: "createdDate",
fixRules:{
fixed:true,
rules:[{field: "consignmentType", option: "EQ", values: ["sale"]}]
},
inputCondition:{
placeholder:'供应商编号/名称/物料编号/名称',
searchCondition:'key',
rules:[{field:"supplier.supplierName-supplier.supplierCode-material.matName-material.matCode", option: "LIKE_ANYWHERE"}]
}
},
configTodo:{
title:'出入库明细',
url:'api/consignment_mat/page',
tabList:['库存结余','出入库明细'],
property: "createdDate",
fixRules:{
fixed:true,
rules:[{field:"consignmentType",option: "EQ",values: ["sale"]}]
},
inputCondition:{
placeholder:'供应商编号/名称/物料编号/名称',
searchCondition:'key',
rules:[{field:"supplier.supplierName-supplier.supplierCode-material.matName-material.matCode",option: "LIKE_ANYWHERE"}]
}
},
list:[],
popupShow:false,
showDetail:{}
}
},
methods:{
getTabIndex(e){
this.tabIndex = e;
},
getList(e,met,bol){
this.$nextTick(()=>{
if(bol){
this.list = this.list.concat(e);
}else{
this.list = e;
}
if(met === 'top'){
this.$refs.loadmore.onTopLoaded();
}
if(met === 'bottom'){
this.$refs.loadmore.onBottomLoaded();
}
})
},
init: function() {

this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
},
loadTop(){
this.$refs.header.getlist(true);
},
loadBottom(){
this.$refs.header.getMore();
},
viewDetail(item){
this.popupShow = true;
this.showDetail = item;
},
},
mounted(){
this.init();
if(this.$route.params.type === 'stock'){
this.$refs.header.tabIndex = 1;
this.tabIndex = 1;
}else if(this.$route.params.type === 'mat'){
this.$refs.header.tabIndex = 2;
this.tabIndex = 2;
}
this.$refs.header.getlist();
}
}



// WEBPACK FOOTER //
// ./src/page/procu-syner/consignment.vue